'use client';

import { useState } from 'react';
import { DidomiSDK } from '@didomi/react';
import { GoogleTagManager } from '@next/third-parties/google';

const SDK_PATH = 'https://sdk.privacy-center.org/';

const Didomi = () => {
	const [isDidomiReady, setIsDidomiReady] = useState(false);

	return (
		<>
			<DidomiSDK
				data-testid="didomi-popup"
				apiKey={process.env.NEXT_PUBLIC_DIDOMI_API_KEY}
				noticeId={process.env.NEXT_PUBLIC_DIDOMI_NOTICE_ID}
				gdprAppliesGlobally={true}
				sdkPath={SDK_PATH}
				onReady={() => {
					setIsDidomiReady(true);
				}}
				onNoticeShown={() => {
					setIsDidomiReady(false);
				}}
				onNoticeHidden={() => {
					setIsDidomiReady(true);
				}}
			/>
			{isDidomiReady && <GoogleTagManager gtmId={process.env.NEXT_PUBLIC_GOOGLE_TAG_ID} />}
		</>
	);
};

export default Didomi;
